import type { DwdCheckStatus } from '@cdw-ae/common-data';
import type { ChipTone } from '../chip-tone';

/**
 * Human-readable label per persisted DWD check status. A map rather than a
 * switch so a status added to common-data fails the build here instead of
 * silently rendering "Not checked".
 */
const DWD_STATUS_LABELS = {
  ok: 'Verified',
  // Spelled out because "ID" is ambiguous on this page: the DWD *Client* ID
  // is a different thing (wizard Step 3). This compares Google's reported
  // CUSTOMER id against the stored google_id.
  id_mismatch: 'Google Customer ID Mismatch',
  dwd_not_granted: 'Not granted',
  delegate_not_found: 'No delegate',
  delegate_lacks_admin: 'No admin role',
  delegate_inactive: 'Inactive account',
  error: 'Check failed',
} satisfies Record<DwdCheckStatus, string>;

const DWD_STATUS_TONES = {
  ok: 'ok',
  id_mismatch: 'warn',
  dwd_not_granted: 'warn',
  delegate_not_found: 'warn',
  delegate_lacks_admin: 'warn',
  delegate_inactive: 'warn',
  error: 'error',
} satisfies Record<DwdCheckStatus, ChipTone>;

/** Label for a persisted DWD check status (null = never run). */
export function dwdStatusLabel(status: DwdCheckStatus | null): string {
  return status ? DWD_STATUS_LABELS[status] : 'Not checked';
}

/** Chip tone for a persisted DWD check status (null = never run). */
export function dwdStatusTone(status: DwdCheckStatus | null): ChipTone {
  return status ? DWD_STATUS_TONES[status] : 'neutral';
}
